<div class="contentContainer">
  <ui-icon-button *ngFor="let button of params.buttonList" [disabled]="buttonDisabled(button)" [title]="button.title" [color]="button.iconColor" [iconName]="button.iconName" [heightInPx]="button.heightInPx" [widthInPx]="button.widthInPx" [screenReaderText]="button.screenReaderText" (clicked)="buttonClicked(button)"></ui-icon-button>
</div>
